import { intersectionWith } from "../libs/arrayUtils";

const compareFilters = (filter1, filter2) => {
  return filter1.templateId === filter2.templateId;
};

export const useModelsGeneralTemplatesFilters = (
  filteredTemplates, filteredVisibilityTemplates, templates
) => {
  const templatesToIterate =
    filteredTemplates.length === 0 && filteredVisibilityTemplates.length === 0
      ? templates
      : filteredTemplates.length > 0 && filteredVisibilityTemplates.length === 0
        ? filteredTemplates
        : filteredTemplates.length === 0 && filteredVisibilityTemplates.length > 0
          ? filteredVisibilityTemplates
          : intersectionWith(
            filteredVisibilityTemplates, filteredTemplates, compareFilters
          );
  return templatesToIterate;
};
